import { Injectable } from '@angular/core';
import { endOfScale, startOfScale } from '@library/store/measures/measures';
import { EnumScales, TimeRange } from '@library/store/measures/measures.interface';
import { CpCompareHeaderCacheService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-header/cp-compare-header-cache.service';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Injectable()
export class CpCompareTimeRangeService {

  secondTimeRange$ = new BehaviorSubject<TimeRange>(null);

  firstTimeRange$ = new ReplaySubject<TimeRange>(1);

  constructor(
    private compareHeaderCacheService: CpCompareHeaderCacheService,
  ) {}

  setSecondTimeRange(timeRange: TimeRange) {
    this.secondTimeRange$.next(timeRange);
    this.compareHeaderCacheService.setSecondTimeRange(timeRange);
  }

  setFirstTimeRange(timeRange: TimeRange) {
    this.firstTimeRange$.next(timeRange);
  }

  addSecondTimeRange(firstTimeRange: TimeRange, scale: EnumScales) {
    const {dateBegin} = firstTimeRange;
    const secondTimeRange = {
      dateBegin: startOfScale(dateBegin.clone().subtract(1, 'day'), scale),
      dateEnd: endOfScale(dateBegin.clone().subtract(1, 'day'), scale),
    };
    this.setSecondTimeRange(secondTimeRange);
  }
}